/**
 * 디바이스 정보 수집
 *
 * User Agent, 화면 해상도, 뷰포트 크기, 브라우저 언어 등 환경 정보 수집
 */

/** 디바이스 정보 */
export interface DeviceInfo {
  screenResolution: string;
  viewportSize: string;
  userAgent: string;
  language: string;
}

/** 디바이스 정보 수집 유틸 */
export function getDeviceInfo(): DeviceInfo {
  if (typeof window === 'undefined') {
    return {
      screenResolution: '',
      viewportSize: '',
      userAgent: '',
      language: '',
    };
  }

  const screen = window.screen;
  const screenResolution = screen
    ? `${screen.width}x${screen.height}`
    : '';

  const viewportSize = `${window.innerWidth}x${window.innerHeight}`;

  const userAgent = typeof navigator !== 'undefined'
    ? navigator.userAgent
    : '';

  const language = typeof navigator !== 'undefined'
    ? navigator.language || ''
    : '';

  return {
    screenResolution,
    viewportSize,
    userAgent,
    language,
  };
}

/** UA 기반 디바이스 타입 감지 */
export function detectDeviceType(): string {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent;
  if (/Mobi|Android.*Mobile|iPhone|iPod/i.test(ua)) return 'mobile';
  if (/iPad|Android(?!.*Mobile)|Tablet/i.test(ua)) return 'tablet';
  return 'desktop';
}

/** UA 기반 브라우저 감지 */
export function detectBrowser(): string {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent;
  if (/Edg\//i.test(ua)) return 'Edge';
  if (/OPR\//i.test(ua) || /Opera/i.test(ua)) return 'Opera';
  if (/SamsungBrowser/i.test(ua)) return 'Samsung Internet';
  if (/Chrome\//i.test(ua) && !/Edg/i.test(ua)) return 'Chrome';
  if (/Safari\//i.test(ua) && !/Chrome/i.test(ua)) return 'Safari';
  if (/Firefox\//i.test(ua)) return 'Firefox';
  return 'Other';
}

/** UA 기반 OS 감지 */
export function detectOS(): string {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent;
  if (/Windows/i.test(ua)) return 'Windows';
  if (/Mac OS X/i.test(ua) && !/iPhone|iPad/i.test(ua)) return 'macOS';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
  if (/Android/i.test(ua)) return 'Android';
  if (/Linux/i.test(ua)) return 'Linux';
  return 'Other';
}
